module.exports = "https://web-assets.ifttt.com/packs/media/docs/private-connection-ff393d3b.png";